import { createContext } from '@lyearn/core/utils/context';

// types
import { HeroProps } from '../types';

const [HeroProvider, useHeroContext] = createContext<HeroProps>('HeroContext');

export { HeroProvider, useHeroContext };
